module.exports = __webpack_public_path__ + "static/banner_action-192a0b13886e7687102f81ff57abaf09.png";